// Helper function to check if date string is invalid
export function isInvalidDateString(dateStr: string): boolean {
  return !dateStr || dateStr === 'N/A' || dateStr === 'Add date' || dateStr === 'Not set' || dateStr === 'Present'
}

// Helper function to parse MM/YYYY format
export function parseMonthYearFormat(dateStr: string): Date | null {
  const parts = dateStr.split('/')
  if (parts.length !== 2) return null
  
  const month = parseInt(parts[0]) - 1
  const year = parseInt(parts[1])
  if (isNaN(month) || isNaN(year)) return null
  
  return new Date(year, month, 1)
}

// Helper function to parse time from string
export function parseTime(timeStr: string): { hours: number; minutes: number } | null {
  const timeParts = timeStr.split(':')
  if (timeParts.length !== 2) return null
  
  const hours = parseInt(timeParts[0])
  const minutes = parseInt(timeParts[1])
  if (isNaN(hours) || isNaN(minutes)) return null
  
  return { hours, minutes }
}

// Helper function to parse date with time
export function parseDateWithTime(
  year: number,
  month: number,
  day: number,
  timePart: string | null,
  includeTime: boolean
): Date | null {
  if (timePart) {
    const time = parseTime(timePart)
    if (time) {
      return new Date(year, month, day, time.hours, time.minutes)
    }
  }
  
  // If no time or includeTime is false, use current time for timestamp fields, midnight for date fields
  if (includeTime) {
    const now = new Date()
    return new Date(year, month, day, now.getHours(), now.getMinutes())
  }
  return new Date(year, month, day)
}

// Helper function to parse DD/MM/YYYY format
export function parseDayMonthYearFormat(dateStr: string, includeTime: boolean): Date | null {
  const parts = dateStr.split(',')
  const datePart = parts[0].trim()
  const timePart = parts[1]?.trim() || null
  const dateParts = datePart.split('/')
  
  if (dateParts.length !== 3) return null
  
  const year = parseInt(dateParts[2])
  const month = parseInt(dateParts[1]) - 1
  const day = parseInt(dateParts[0])
  
  if (isNaN(year) || isNaN(month) || isNaN(day)) return null
  
  return parseDateWithTime(year, month, day, timePart, includeTime)
}

// Helper function to get days in month
export function getDaysInMonth(month: number, year: number): number {
  return new Date(year, month + 1, 0).getDate()
}

// Helper function to get first day of month
export function getFirstDayOfMonth(month: number, year: number): number {
  return new Date(year, month, 1).getDay()
}
